import EventEmitter from "base/EventEmitter";
import "blueimp-file-upload";
import "blueimp-file-upload/js/jquery.fileupload-process";
import "blueimp-file-upload/js/jquery.fileupload-image";

class FileUploader extends EventEmitter {
    constructor($element, settings = {}) {
        super();

        this.settings = $.extend(true, {}, FileUploader.DEFAULT_SETTINGS, settings);

        if (Array.isArray(this.settings.extensions) && this.settings.extensions.length > 0) {
            this.settings.accept = this.settings.extensions.map((ext) => '.' + ext).join(',');
        }

        this.files = [];
        this.uploadingRequests = {};
        this.removedFiles = {};

        this.$element = $element;

        this.$progressHolder = this.$element.find('.js-files');
        this.$button = this.$element.find('.js-upload-button');

        this.createFileUploader();
        this.bindEvents();
    }

    getFiles() {
        return this.files.filter((file) => file.wordpressId).map((file) => {
            return file.wordpressId;
        });
    }

    trigger() {
        this.$file.click();
    }

    bindEvents() {
        const me = this;

        if (this.$progressHolder !== null) {
            this.$progressHolder.on("click", ".js-retry", function () {
                let data = $(this).closest(".js-file-item").data("context");
                data.submit();

                $(data.context).find('.js-buttons').html([
                    eotwJSXFactory('div', {className: "file__status file__status--loading"}),
                    eotwJSXFactory('button', {type: "button", className: "file__remove js-remove"})
                ]);
                return false;
            }).on("click", ".js-remove", function () {
                me.removeFile($(this).parents(".js-file-item").data("file"));

                return false;
            }).on("mousedown", ".js-remove", function (e) {
                e.stopPropagation();
            });
        }

        this.$button.on("click", () => {
            this.trigger();
            return false;
        });
    }

    createFileUploader() {
        let $file = eotwJSXFactory('input', {className: "js-no-validate", type: "file", style: "display:none;", multiple: this.settings.allowMultiple, accept: this.settings.accept});
        this.$button.after($file);

        this.$file = $file;

        $file.fileupload($.extend(true, {}, {
            dataType: 'json',
            paramName: 'file',
            add: this.handleAddedFile.bind(this),
            submit: this.handleSubmitFile.bind(this),
            done: this.handleDoneUpload.bind(this),
            fail: this.handleFailedUpload.bind(this),
            url: '/wp-json/eotw/file-upload',
            type: 'POST',
            replaceFileInput: false,
        }, this.settings.uploaderSettings));

        this.fileupload = $file.data("blueimpFileupload");
    }

    addFile(file) {
        file = $.extend(true, {}, file);

        let $progress = this.createProgressRow(file);

        if (this.$progressHolder !== null) {
            this.$progressHolder.append($progress);
        }

        file.context = $progress;
        file.$progress = $progress;

        file.emitter = new EventEmitter();

        file.wordpressId = 0;
        file.thumbnail = false;

        this.files.push(file);

        this.emit(EVENT_CHANGE);

        if (file.id) {
            this.emit(EVENT_EXISTING_FILE_ADDED, file);
        }
        return file;
    }

    setFiles(files) {
        this.files.forEach((file) => {
            file.emitter.emit(EVENT_FILE_REMOVED, file);
            file.$progress.remove();
        });

        this.files = [];

        files.forEach((file) => {
            this.addFile(file);
        });
    }

    removeFile(file) {
        if (!this.settings.allowRemoving && file.id) return;
        if (file.emitter) {
            file.emitter.emit(EVENT_FILE_REMOVED, file);
        }
        let data = file.context.data("context");

        file.context.remove();

        this.files = this.files.filter((other) => other !== file);

        if (data) {
            if (this.uploadingRequests[data.ID]) {
                data.abort();
            }
            delete this.uploadingRequests[data.ID];
            this.removedFiles[data.ID] = true;
        }

        this.emit(EVENT_CHANGE);
        this.checkUploadingRequests();
    }

    handleAddedFile(e, data) {
        data.ID = FileUploader.CURRENT_ID++;

        let file = data.files[0];

        let nameParts = file.name.split(".");
        let extension = '';
        if (nameParts.length > 1) {
            extension = nameParts.pop();
        }

        let name = nameParts.join('.');
        let fileData = {
            name: name, label: name, extension: extension, fullName: name + (extension.length > 0 ? '.' + extension : ''), size: file.size,
        };

        fileData = this.addFile(fileData);
        data.context = fileData.context;
        data.context.data("request", data);
        data.context.data("context", data);
        data.emitter = fileData.emitter;

        this.fileupload.process(data).done(async () => {
            file = data.files[0];
            data.submit();
        });
    }

    handleSubmitFile(e, data) {
        if (this.removedFiles[data.ID]) {
            return;
        }
        this.uploadingRequests[data.ID] = data;
        this.checkUploadingRequests();

        data.formData = {};
    }

    handleDoneUpload(e, data) {
        let response = data.result;

        if (response.success === true) {
            this.handleSuccessfulUpload(data);
        } else {
            delete this.uploadingRequests[data.ID];
            console.warn("Couldn't upload image", response);
            this.displayError(data.context);

            this.emit(EVENT_FILE_ERROR, {
                message: response.message, file: data,
            });
            data.emitter.emit(EVENT_FILE_ERROR, {
                message: response.message, file: data,
            });
        }
        this.checkUploadingRequests();
    }

    displaySuccess($element, img) {
        if (this.$progressHolder === null) {
            return;
        }

        if (img) {
            $element.find('.file__img').html(eotwJSXFactory('img', {src: img, class: "bg-image"}));
        }

        $element.addClass("file--done");
        $element.find(".js-buttons").html([eotwJSXFactory('div', {className: "file__status"}), eotwJSXFactory('button', {type: "button", className: "file__remove js-remove"})]);
    }

    handleSuccessfulUpload(data) {

        try {
            if (this.removedFiles[data.ID]) {
                // This file haas been cancelled, don't do anything more
                this.checkUploadingRequests();
                return;
            }

            let file = this.uploadingRequests[data.ID];
            file.wordpressId = data.result.image;
            file.thumbnail = data.result.thumbnail;

            this.emit(EVENT_FILE_UPLOADED, file);
            data.emitter.emit(EVENT_FILE_UPLOADED, file);

            $.extend(data.context.data("file"), file);
            this.emit(EVENT_CHANGE);

            delete this.uploadingRequests[data.ID];
            this.displaySuccess(data.context, file.thumbnail);
        } catch (e) {
            delete this.uploadingRequests[data.ID];

            console.error("Couldn't finish upload", e);

            this.displayError(data.context);

            this.emit(EVENT_FILE_ERROR, {
                message: e.message, file: data,
            });

            data.emitter.emit(EVENT_FILE_ERROR, {
                message: e.message, file: data,
            });
        }
        this.checkUploadingRequests();
    }

    handleFailedUpload(e, data) {
        delete this.uploadingRequests[data.ID];
        this.checkUploadingRequests();

        this.displayError(data.context);

        let text = data.jqXHR.responseText;
        let message = "Connection error";

        try {
            let jsonData = JSON.parse(text);
            if (jsonData.message) {
                message = jsonData.message;
            }
        } catch (e) {
            //Noop

        }

        this.emit(EVENT_FILE_ERROR, {
            message: message, file: data,
        });

        data.emitter.emit(EVENT_FILE_ERROR, {
            message: message, file: data,
        });
    }

    displayError($element) {
        if (this.$progressHolder === null) {
            return;
        }

        $element.addClass("file--error");
        $element.find(".js-buttons").html([eotwJSXFactory('button', {type: "button", className: "file____btn-text js-retry"}, ["Retry"]), eotwJSXFactory('span', {className: "file__status-text"}, ["Upload failed"]), eotwJSXFactory('div', {className: "file__status file__status--fail"}), eotwJSXFactory('button', {type: "button", className: "file__remove js-remove"}),]);
    }

    createProgressRow(file) {
        if (this.$progressHolder === null) {
            return (eotwJSXFactory('div')).data("file", file);
        }
        return (eotwJSXFactory('div', {className: "file js-file-item"}, [
            eotwJSXFactory('div', {className: "file__img"}),
            eotwJSXFactory('div', {className: "file__details"}, [
                eotwJSXFactory('span', {className: "file__name"}, [file.fullName]),
                eotwJSXFactory('span', {className: "file__size js-file-size"}, [ValueHelper.format_bytes(file.size)])
            ]),
            eotwJSXFactory('div', {className: "file__actions js-buttons"}, [
                eotwJSXFactory('div', {className: "file__status file__status--loading"}),
                eotwJSXFactory('button', {type: "button", className: "file__remove js-remove"})
            ])
        ])).data("file", file);
    }

    checkUploadingRequests() {
        if (Object.keys(this.uploadingRequests).length > 0) {
            this.emit(EVENT_UPLOADING);
        } else {
            this.emit(EVENT_DONE);
        }
    }
}

FileUploader.CURRENT_ID = 0;

FileUploader.DEFAULT_SETTINGS = {
    allowMultiple: true,
    allowOrdering: false,
    allowEditFileName: false,
    allowRemoving: true,
    extensions: [],
    accept: null,
    uploaderSettings: {},
};

export default FileUploader;

export const EVENT_FILE_ADDED = 'fileAdded';
export const EVENT_EXISTING_FILE_ADDED = 'existingFileAdded';
export const EVENT_FILE_REMOVED = 'fileRemoved';
export const EVENT_UPLOADING = 'uploading';
export const EVENT_FILE_UPLOADED = 'fileUploaded';
export const EVENT_DONE = 'done';
export const EVENT_FILE_ERROR = 'fileError';
export const EVENT_CHANGE = 'change';
export const EVENT_FILE_PROGRESS = 'fileProgress';